import {useState, useEffect } from 'react';
import Product from '../Product/Product';
import { useSelector,useDispatch } from 'react-redux';
import { uiActions } from '../../store';
import styles from './ProductList.module.css'


export default function ProductList({seriesId, thumbSize, handleSelect,handleCartAction,dropdownFilters,searchFilters}) {


    const dispatch = useDispatch();
    const [productData, setproductData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState();
    const sampleCart = useSelector(state => state.visualizer.sampleCart);
    const selString = useSelector((state) => state.visualizer.selString);

    const handleProductSelect = function(id) {
        if(id != selectedProduct){
            handleSelect(id);
            setSelectedProduct(id);
            dispatch(uiActions.setVizLoading(true));
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const chamViz = document.getElementById("chamViz");
        if (chamViz) {
            chamViz.addEventListener('surface_apply_done', function (result) {
                let sel = chamViz.getSaveData().sel;
                if (sel != -1) {
                    setSelectedProduct(parseInt(sel.split('(')[0]));
                }
            });
        }
    });
    
    useEffect(() => {
        const URL = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
        
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {

                let filteredData = data;
                if(Object.keys(searchFilters || {}).length > 0){
                    Object.entries(searchFilters).forEach(([column, value]) => {
                        filteredData = filteredData.filter(prod =>
                            prod[column]?.toLowerCase().includes(value.toLowerCase())
                        );
                    });
                }

                if(Object.keys(dropdownFilters || {}).length > 0){
                    Object.entries(dropdownFilters).forEach(([column, value]) => {
                        if (value && value != -1) {
                            filteredData = filteredData.filter(prod => prod[column] === value);
                        }
                    });
                }


                setproductData(filteredData);
            })
    }, [seriesId, dropdownFilters]); 
    

    //console.log('selectedProduct',selectedProduct)
    let productItems = productData.map(product => <Product 
        key={product.id}
        focus={500}
        size={thumbSize} 
        product={product}
        onSelect={handleProductSelect}
        isActive={product.id === selectedProduct?true:false}
        cartAction={handleCartAction}
        isInCart={sampleCart.hasOwnProperty(product.id)}
        />)

    return(
        <ul className={styles.productList} data-series={seriesId}>
            {productItems}
        </ul>
    );
}